import React from 'react'
import App from '../components/app'
import Head from 'react-helmet'
import Header from '../components/header'
import Footer from '../components/footer'
import WufooForm from 'react-wufoo-embed'
import ContactHero from '../components/contactHero'
import Hero from '../components/hero'
import Wave2 from '../components/wave2'
import ContactForm from '../components/contactForm'

const Contact = () => {
  return (
    <App>
      <Head>
        <title>Contact Us | Silver State Pediatric</title>
      </Head>

      <Header />

      <main>
        <Hero title="Contact" image="https://images.unsplash.com/photo-1524503033411-c9566986fc8f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80" backgroundPosition="center bottom" /> 
        <Wave2 />
        <section className="contact">
          <div className="container">
             <h1>Get in touch!</h1>
             <p>For additional information, please feel free to use the contact form below and we will get back to you as soon as possible.</p>
             <ContactForm />
          </div> 
          
        </section> 
        <div className="iframe-holder">
                  <iframe
                    title="Contact Us"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3221.281869055928!2d-115.17855468434476!3d36.1596949800855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c8c3e89a88a59f%3A0x8d3be4e2eb70231b!2s2496%20W%20Charleston%20Blvd%2C%20Las%20Vegas%2C%20NV%2089102!5e0!3m2!1sen!2sus!4v1577077290778!5m2!1sen!2sus"
                    frameBorder="0"
                    allowFullScreen=""
                  ></iframe>
                </div>
       
      </main>

      <Footer />
      <style jsx>{`
        section {
          padding-top: 4rem;
          padding-bottom: 8rem;
          margin: auto;
          width: 100%;
        }
   
        h1 {
          font-size: 2.2rem;
          text-align: center;
          margin: 0;
          margin-bottom: 1rem;
          color: #233E94;
        }
        h1:before {
          content: "";
          position: absolute;
          height: 5px;
          background: #F69C1F;
          width: 35px;
          top: 3.2rem;
          border-radius: 3px;
        }
        p {
          margin: auto;
          text-align: center;
        }
       
        .iframe-holder {
          position: relative;
          padding-top: 10%;
          margin-bottom: 12rem;
          height: 40vh;
        }
        .iframe-holder iframe {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          height: 70vh;
        }

        @media (max-width: 760px) {
          section {
            padding-top: 5rem;
            padding-bottom: 5rem;
          }
          h1 {
            font-size: 1.7rem;
            text-align: center;
          }
          h1:before {
            display: none;
          }
          p {
            font-size: 1rem;
            text-align: center;
          }
          .iframe-holder {
            position: relative;
            padding-top: 0;
            margin-bottom: 0rem;
            height: 50vh;
          }
          .iframe-holder iframe {
            position: relative;
            width: 100%;
            height: 100%;
            height: 50vh;
          }
        }
        
      `}</style>
    </App>
  )
}

export default Contact
